/**
 * Member-portal functions, moved out of the checkout bundle in 1.6.0 (G-8,
 * konnektive-one#6). Built as dist/membership.js, a separate webpack entry, so
 * engine.js no longer carries them.
 *
 * ASSUMPTION (G-8): kept as a separate file rather than deleted, so the code is
 * at hand for the rebuild on the #9 membership proxy (konnektive-one#4, ops
 * M-3). Nothing loads it today: member portals are shut down (ops#9). The calls
 * below still go to konnektiveAPIURL (#7) and stop working once #7 is deleted;
 * do not load this file on a live page until konnektive-one#4 repoints it.
 *
 * Load after engine.js. It reads the engine's config and helpers from the
 * window globals engine.js exposes, so both files share one config and one
 * session (a bundled copy of config.js would hold an empty config of its own).
 */
import $ from 'jquery';
import { buildPageUrl } from './routing';

const engine = (name) => (...args) => window[name](...args);
const getConfig = engine('getConfig');
const debug = engine('debug');
const throwError = engine('throwError');
const resetFormState = engine('resetFormState');
const getCookieValue = engine('getCookieValue');
const deleteSessionStorage = engine('deleteSessionStorage');
const buildQuery = engine('buildQuery');
const getKNKBillingModels = engine('getKNKBillingModels');
const setStates = engine('setStates');
// Defined by the member pages themselves, not by the engine.
const loadUserOrders = (...args) => window.loadUserOrders(...args);
// Read at call time: constants live in the engine bundle.
const orderIcon = () => window.ORDER_ICON_PLACEHOLDER;

export function konnektive_validate_user(user_email, order_id) {

	const settings = {
		url: `${getConfig().konnektiveAPIURL}/order/query?` + 
			`&orderId=` + order_id +
			`&emailAddress=` + user_email,
		method: 'POST',
		timeout: 0,
		headers: {
			'X-SESSION-ID': ''
		}
	};
	let user_valid = $.ajax(settings).done((response) => {
		if (response.result == "SUCCESS") {
				konnektive_create_member(user_email); // let's set a new random password and email it to user
		} else {
			debug(response);
			throwError('error', response.message);
		}
	});
}

export function konnektive_create_member(user_email) {
	const settings = {
		url: `${getConfig().konnektiveAPIURL}/members/reset?` + 
			`&clubId=` + getConfig().clubID +
			`&clubUsername=` + user_email,
		method: 'POST',
		timeout: 0,
		headers: {
			'X-SESSION-ID': ''
		}
	};

	$.ajax(settings).done((response) => {
		if (response.result == "SUCCESS") {
			resetFormState();
			throwError('info', response.message);
		} else {
			debug(response);
			resetFormState();
			throwError('error', response.result);
		}
	});
}


export function konnektive_login_user(customer_email, customer_password) {

	var expDate = new Date();
	expDate.setTime(expDate.getTime() + (1440 * 60 * 1000)); // add 24 hours

	const settings = {
		url: `${getConfig().konnektiveAPIURL}/members/login?` + buildQuery({
			clubId: getConfig().clubID,
			clubUsername: customer_email,
			clubPassword: customer_password,
		}),
		method: 'POST',
		timeout: 0,
		headers: {
			'X-SESSION-ID': ''
		}
	};

	$.ajax(settings).done((response) => {
		// Konnektive /members/login returns { result:"SUCCESS", message:{ memberId, status, ... } }
		// (no access_token — that field only exists on the legacy provider response).
		if (response.result === 'SUCCESS' && response.message && response.message.memberId) {
			resetFormState();
				document.cookie = `konnektive_customer_email=${customer_email};path=/;expires=${expDate}`;
				document.cookie = `konnektive_customer_id=${response.message.memberId};path=/;expires=${expDate}`;
				document.cookie = `member_token=${response.message.memberId};path=/;expires=${expDate}`;
				sessionStorage.setItem('konnektive_customer_id', response.message.memberId);
				sessionStorage.setItem('konnektive_customer_email', customer_email);
				sessionStorage.setItem('member_token', response.message.memberId);
				// Respect pageExtension: hosts serving extensionless routes set it to '',
				// and a hardcoded .html there costs a redirect (or 404s).
				window.location.href = buildPageUrl('member', getConfig().pageExtension);
				$('#logform')[0].reset();
			} else {
				// Konnektive ERROR responses carry the reason as a string message,
				// e.g. "Access Denied: Invalid member credentials".
				throwError('error', typeof response.message === 'string' ? response.message : 'Login failed. Please check your email and password.');
				$('#sForm #sFormOverlay').remove();
				$('#sForm button[type="submit"]').show();
			}
	}).fail((jqXHR, textStatus, error) => {
		console.log(`Mailer Error: `, textStatus, error);
		$('#sForm #sFormOverlay').remove();
		$('#sForm button[type="submit"]').show();
	});
}

export function konnektive_user_orders_lookup(){
	$('.overlay, .processing').show();
	$('#order_summary tbody').html('');

	var visiblescienceCampaignSettings = '';
	if(getConfig().campaignID.length){
		visiblescienceCampaignSettings = `&campaignId=`;
		$.each(getConfig().campaignID, (cnum, cval) =>{
			visiblescienceCampaignSettings	+= cval.id + ',';
		})
	}

	var separateOrders = false;
	if($('#subscription_summary').length){
		separateOrders = true;
	}

	const settings = {
		url: `${getConfig().konnektiveAPIURL}/order/query?` + 
			`&emailAddress=` +  sessionStorage.getItem('konnektive_customer_email') +
			`&resultsPerPage=100` +  
			`&orderStatus=SALE` +
			visiblescienceCampaignSettings +
			`&startDate=` + new Date.parse('today').add(-1).year().toString('MM/dd/yyyy') +
			`&endDate=` + new Date.parse('today').add(1).day().toString('MM/dd/yyyy'),
		method: 'POST',
		timeout: 0,
		headers: {
			'X-SESSION-ID': ''
		}
	};

	$.ajax(settings).done((response) => {
		if (response.result == "SUCCESS") {
			debug(response);
			let orderInfo = '';
			let subscriptionInfo = '';
// orders loop
			$.each(response.message.data, (i, orderBody) => {

				let orderType = 'onetime';
				let rebillInfo = 'One Time Purchase';
				let orderStatus = '';
				let mobileOnlyInfo = '';
				let orderContents = '';
				let rowtypeclassName = 'table-light';
				const orderPlacementDate = orderBody.dateCreated; // new Date(orderBody.dateCreated.substr(0, orderBody.dateCreated.indexOf(' '))).toString('MMMM d, yyyy');

				$.each(orderBody.items, (ocID, ocBody) => {
					
					if(ocBody.purchaseStatus != ''){
						
						let recurringDate = new Date(ocBody.nextBillDate).toString('MMM d, yyyy');
						rebillInfo = 'Subscription';
						orderType = 'subscription';
						if(ocBody.nextBillDate){
							rebillInfo += `<br/><small>Next Shipment: ${recurringDate}</small>`;
						}	
						orderStatus = ocBody.purchaseStatus;

						if(ocBody.purchaseStatus == 'ACTIVE' || ocBody.purchaseStatus == 'TRIAL'){
							rowtypeclassName = 'table-success';
						}
						if(ocBody.purchaseStatus == 'INACTIVE'){
							rowtypeclassName = 'table-danger';
						}

						if(ocBody.purchaseStatus == 'CANCELLED'){
							rowtypeclassName = 'table-secondary';
						}

					} else {
						orderStatus = orderBody.orderStatus;
						
						if(orderBody.orderStatus == 'COMPLETE'){
							rowtypeclassName = 'table-success';
						}
						if(orderBody.orderStatus == 'CANCELLED'){
							rowtypeclassName = 'table-secondary';
						}
					}

					const actionButtonCode = `<a href="#" onclick="konnektive_user_order_details('${orderBody.orderId}', '${btoa(orderBody.emailAddress)}', '${orderType}'); return false;" class="btn btn-secondary w-100"><span class="desktop">Details</span><span class="mobile"><i class="bi bi-info-circle-fill"></i></span></a>`;


					if(ocBody.variantName){
						ocBody.name += "<br/><small>" + ocBody.variantName + "</small>";
					}

					mobileOnlyInfo = `<div class="mobileOnly">$${orderBody.totalAmount}<br/>${orderStatus}<br/>${rebillInfo}</div>`;

					if(separateOrders){
						if(orderType == 'subscription') {
							
						subscriptionInfo += `<tr id="order-entry-${orderBody.orderId}-${orderBody.actualOrderId}" data-pid="${orderBody.actualOrderId}" data-shippable="" class="${rowtypeclassName} ty-order-entry order-entry-${orderBody.orderId}-${orderBody.actualOrderId}">`;
						subscriptionInfo += `<td>${orderBody.orderId}</td>`;
						subscriptionInfo += `<td><div style="display:flex;gap:10px;"><img src="${orderIcon()}" class="product-image oms-entry" data-pid="${ocID}" id="product-${ocID}" /><div>${ocBody.name}${mobileOnlyInfo}</div></div></td>`;
						subscriptionInfo += `<td class="hideOnMobile">${orderPlacementDate}</td>`;
						subscriptionInfo += `<td class="hideOnMobile">${rebillInfo}</td>`;
						subscriptionInfo += `<td class="hideOnMobile">$${ocBody.price}</td>`;
						subscriptionInfo += `<td class="hideOnMobile">${orderStatus}</td>`;
						subscriptionInfo += `<td class="align-top orderDetails" align="center">${actionButtonCode} </td>`;
						subscriptionInfo += '</tr>';						
							
							return;
						}
					}

					orderInfo += `<tr id="order-entry-${orderBody.orderId}-${orderBody.actualOrderId}" data-pid="${orderBody.actualOrderId}" data-shippable="" class="${rowtypeclassName} ty-order-entry order-entry-${orderBody.orderId}-${orderBody.actualOrderId}">`;
					orderInfo += `<td>${orderBody.orderId}</td>`;
					orderInfo += `<td><div style="display:flex;gap:10px;"><img src="${orderIcon()}" class="product-image oms-entry" data-pid="${ocID}" id="product-${ocID}" /><div>${ocBody.name}${mobileOnlyInfo}</div></div></td>`;
					orderInfo += `<td class="hideOnMobile">${orderPlacementDate}</td>`;
					orderInfo += `<td class="hideOnMobile">${rebillInfo}</td>`;
					orderInfo += `<td class="hideOnMobile">$${ocBody.price}</td>`;
					orderInfo += `<td class="hideOnMobile">${orderStatus}</td>`;
					orderInfo += `<td class="align-top orderDetails" align="center">${actionButtonCode} </td>`;
					orderInfo += '</tr>';
				})
			})
// orders loop

				$('#order_summary tbody').html('');
				$('#order_summary tbody').append(orderInfo);
				$('#order_summary tbody tr').each(function() {
				});

				if(separateOrders){
					$('#subscription_summary tbody').html('');
					$('#subscription_summary tbody').append(subscriptionInfo);
					$('#subscription_summary tbody tr').each(function() {});
				}
			
			$.bootstrapSortable({
				sign: 'reversed',
			});
			
			konnektive_user_orders_set_images();
			resetFormState();
		} else {
			debug(response);
			resetFormState();
			throwError('error', response.message);
		}
	});

}


export function konnektive_user_order_details(order_id, email_address, order_type) {
	$('.overlay, .processing').show();
	const trackingInfo = '';

	var separateOrders = false;
	if($('#subscription_summary').length){
		separateOrders = true;
	}

		const settings = {
			url: `${getConfig().konnektiveAPIURL}/order/query?orderId=` + order_id,
			method: 'POST',
			timeout: 0,
			headers: {
				'X-SESSION-ID': ''
			}
		};

		$.ajax(settings).done((response) => {
			if (response.result == "SUCCESS") {
/* help */
				debug(response);

				if(!response.message.data[0].address2 || response.message.data[0].address2 == 'undefined'){
					response.message.data[0].address2 = '';
				}

				if(!response.message.data[0].shipAddress2 || response.message.data[0].shipAddress2 == 'undefined'){
					response.message.data[0].shipAddress2 = '';
				}
				
				$('.updateOrderDetails .btn').show();
				
				const shippingInformation = `<table class="table table-bordered"><thead><tr><th scope="col" colspan="2">Delivery Information</th></tr></thead><tbody><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Name:</strong></td><td id="fullname" class="tab_cel2"><input type="text" id="newShippingFName" placeholder="First Name" value="${response.message.data[0].shipFirstName}" class="form-control half" required><input type="text" id="newShippingLName" placeholder="Last Name" value="${response.message.data[0].shipLastName}" class="form-control half" required></td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Address 1:</strong></td><td id="address" class="tab_cel2"><input type="text" id="newShippingAddress" placeholder="Address" value="${response.message.data[0].shipAddress1}" class="form-control" required></td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Address 2:</strong></td><td id="address2" class="tab_cel2"><input type="text" id="newShippingAddress2" placeholder="Address" value="${response.message.data[0].shipAddress2}" class="form-control" ></td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>City/State:</strong></td><td id="city_state" class="tab_cel2"><input type="text" id="newShippingCity" placeholder="City" value="${response.message.data[0].shipCity}" class="form-control half" required><select id="newShippingState" class="form-select half"></select></td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Zip:</strong></td><td id="zip" class="tab_cel2"><input type="text" placeholder="Zip" id="newShippingZip" value="${response.message.data[0].shipPostalCode}" class="form-control" required></td></tr></tbody></table>`;

				const shippingInformationRO = `<table class="table table-bordered"><thead><tr><th scope="col" colspan="2">Delivery Information</th></tr></thead><tbody><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Name:</strong></td><td id="fullname" class="tab_cel2">${response.message.data[0].shipFirstName} ${response.message.data[0].shipLastName}</td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Address 1:</strong></td><td id="address" class="tab_cel2">${response.message.data[0].shipAddress1}</td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Address 2:</strong></td><td id="address2" class="tab_cel2">${response.message.data[0].shipAddress2}</td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>City/State:</strong></td><td id="city_state" class="tab_cel2">${response.message.data[0].shipCity}, ${response.message.data[0].shipState}</td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Zip:</strong></td><td id="zip" class="tab_cel2">${response.message.data[0].shipPostalCode}</td></tr></tbody></table>`;
				
				
				const billingInformation = `<table class="table table-bordered"><thead><tr><th scope="col" colspan="2">Billing Information</th></tr></thead><tbody><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Name:</strong></td><td id="fullname" class="tab_cel2"><input type="text" id="newBillingFName" placeholder="First Name" value="${response.message.data[0].firstName}" class="form-control half" required><input type="text" id="newBillingLName" placeholder="Last Name" value="${response.message.data[0].lastName}" class="form-control half" required></td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Address 1:</strong></td><td id="address" class="tab_cel2"><input type="text" id="newBillingAddress" placeholder="Address" value="${response.message.data[0].address1}" class="form-control" required></td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Address 2:</strong></td><td id="address2" class="tab_cel2"><input type="text" id="newBillingAddress2" placeholder="Address" value="${response.message.data[0].address2}" class="form-control" ></td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>City/State:</strong></td><td id="city_state" class="tab_cel2"><input type="text" id="newBillingCity" placeholder="City" value="${response.message.data[0].city}" class="form-control half" required><select id="newBillingState" class="form-select half"></select></td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Zip:</strong></td><td id="zip" class="tab_cel2"><input type="text" placeholder="Zip" id="newBillingZip" value="${response.message.data[0].postalCode}" class="form-control" required></td></tr></tbody></table>`;
				
				const billingInformationRO = `<table class="table table-bordered"><thead><tr><th scope="col" colspan="2">Billing Information</th></tr></thead><tbody><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Name:</strong></td><td id="fullname" class="tab_cel2">${response.message.data[0].firstName} ${response.message.data[0].lastName}</td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Address 1:</strong></td><td id="address" class="tab_cel2">${response.message.data[0].address1}</td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Address 2:</strong></td><td id="address2" class="tab_cel2">${response.message.data[0].address2}</td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>City/State:</strong></td><td id="city_state" class="tab_cel2">${response.message.data[0].city}, ${response.message.data[0].state}</td></tr><tr><td class="tab_cel1 col-md-4 col-lg-3 text-right"><strong>Zip:</strong></td><td id="zip" class="tab_cel2">${response.message.data[0].postalCode}</td></tr></tbody></table>`;			
				
				let orderContentsInfo = ``;
				let billingModelInfo = ``;
				let downloadHTML = '';
				var showRO = false;

				globalsOrderId = response.message.data[0].clientOrderId;

					$.each(response.message.data[0].items, function(k, v) {
						if (k == 0) return;

						if(v.variantName){
							v.name += " &mdash; " + v.variantName + "";
						}

						if(separateOrders){
							if(order_type == "onetime"){
								if(v.variantName.indexOf('cription') != -1)
									return;
							} else {
								if(v.variantName.indexOf('cription') == -1)
									return;							
							}
						}

						if(v.purchaseStatus == '' || v.purchaseStatus == "CANCELLED"){
							$('.updateOrderDetails .btn').hide();
							showRO = true;
						}

						orderContentsInfo += `<tr><td class="tab_cel1 text-right orderContents freeGift"><i class="bi bi-gift"></i> ${v.name}</td><td>$${v.price}</td></tr>`;

//						orderContentsInfo += '<tr class="virtualProduct"><td colspan="2" class="tab_cel1 text-right" data-pid="' + v.actualProductId + '"><div class="spinner-border text-secondary" role="status"><span class="visually-hidden">Loading...</span></div></td></tr>' // dynamic download
//						if (v.is_shippable == 0) {
//							setVirtualLink(v.actualProductId);
//						}

						const billingSelectDropdown = `<select id="billingModelUpdate" name="billingModelUpdate" class="form-select" aria-label="Default select example"><option value="" disabled selected> - Change billing cycle - </option>${getKNKBillingModels()}</select>`;

						if (v.purchaseStatus != '') {
							const recurringDate = new Date(v.nextBillDate).toString('MMM d, yyyy');
							var recurringDate2 = new Date(v.nextBillDate).toString('MM/dd/yyyy');
							var recurringInfo = `<strong>Subscription</strong>`;
							if(v.nextBillDate){
								recurringInfo += `<br/>Next shipment date: ${recurringDate}`;	
							}
							
						} else {
							var recurringInfo = 'One Time Purchase';
						}
							billingModelInfo = `<tr><td colspan="2" class="tab_cel1 text-right"> ${recurringInfo}</td></tr>`;
							if (v.purchaseStatus != '' && v.purchaseStatus != 'CANCELLED') {
								billingModelInfo += '<tr><td colspan="2" class="tab_cel1 text-right">';
								if (v.purchaseStatus == 'ACTIVE' || v.purchaseStatus == 'TRIAL') {
									billingModelInfo += `<a class="btn btn-danger" href="#" onclick="konnektive_update_order_subscription('${globalsOrderId}', '${v.purchaseId}', 'subscription_stop'); return false;"><i class="bi bi-pause-fill"></i> Cancel Subscription</a>`;
								}
								if (v.purchaseStatus == 'INACTIVE') {
									billingModelInfo += ` <a class="btn btn-success" href="#" onclick="konnektive_update_order_subscription('${globalsOrderId}', '${v.purchaseId}', 'subscription_restart'); return false;"><i class="bi bi-play-fill"></i> Resume Subscription</a>`;
								}
								billingModelInfo += '</td></tr>';
								billingModelInfo += `<tr><td colspan="2" class="tab_cel2 bilcycle">${billingSelectDropdown} <label>New Next Bill Date:</label> <input type="text" value="${recurringDate2}" class="form-control" name="newRecurringDate" id="newRecurringDate" data-format="MM/dd/yyyy" autocomplete="off" /> <a href="#" onclick="konnektive_update_order_subscription('${globalsOrderId}', '${v.purchaseId}', 'billing_model'); return false;" class="btn btn-primary">Save</a></td></tr>`;
							}

//						orderContentsInfo += `<tr><td colspan="2" class="tab_cel1 text-right">${recurringInfo}</td></tr>`;
						orderContentsInfo += billingModelInfo;

						if (response.message.data[0].tracking_number) {
							$('#trackNumber').html(`<tr><td>${response.tracking_number} <a href="#" target="_blank" id="shipmentTrackingLink">Track Shipment</a></td></tr>`);
							$('.trackingCol').show();
							detectCarrier(response.tracking_number);
						} else {
							$('.trackingCol').hide();
						}


//						if (response.message.data[0].tracking_number) { 
//						}
	
//						if (response.products[0].is_shippable == 0) {
//							var downloadHTML = '<tr class="virtualProduct"><td class="tab_cel1 text-right" data-pid="' + response.products[0].product_id + '"><div class="spinner-border text-secondary" role="status"><span class="visually-hidden">Loading...</span></div></td></tr>';
//						} else {

//						}
					})

					$('#orderModal h5').text(`Order #${globalsOrderId}`);
					$('#orderModal .modal-body #shippingInfo').html(shippingInformation);
					
					if(showRO){
						$('#orderModal .modal-body #shippingInfo').html(shippingInformationRO);	
					}
					
					$('#orderModal .modal-body #billingInfo').html(billingInformation);
					
					if(showRO){
						$('#orderModal .modal-body #billingInfo').html(billingInformationRO);
					}
					
					$('#orderModal .modal-body #orderContents').html(orderContentsInfo);
					$('#orderModal .modal-body #billingModel').append(downloadHTML);
					$('#orderModal .modal-body .billingModelCol').hide();
					$('#newRecurringDate').datepicker({
						autoclose: true,
						format: 'mm/dd/yyyy',
						todayHighlight: true,
					});

					if (response.tracking_number) { // disable order editing for shipped orders and one-time purchases
						$('#orderModal .modal-body #shippingInfo input, #orderModal .modal-body #shippingInfo select').attr("disabled", "true");
						$('#orderModal .modal-body #billingInfo input, #orderModal .modal-body #billingInfo select').attr("disabled", "true");
						$('.updateOrderDetails .btn').hide();
					}

//					if (response.products[0].is_shippable == 0) {
//						setVirtualLink(response.products[0].product_id);
//					}

					setStates("newShippingState", response.message.data[0].shipState);
					setStates("newBillingState", response.message.data[0].state);

					resetFormState();
					$('#orderModalOpener').click();
/* help */
			} else {
				debug(response);
				resetFormState();
				throwError('error', response.message);
			}
		});
}


export function konnektive_update_order(order_id){
	$('.overlay, .processing').show();
	const settings = {
		url: `${getConfig().konnektiveAPIURL}/order/update?` + buildQuery({
			orderId: order_id,
			shipFirstName: $('#newShippingFName').val(),
			shipLastName: $('#newShippingLName').val(),
			shipAddress1: $('#newShippingAddress').val(),
			shipAddress2: $('#newShippingAddress2').val(),
			shipCity: $('#newShippingCity').val(),
			shipState: $('#newShippingState').val(),
			shipPostCode: $('#newShippingZip').val(),
			firstName: $('#newBillingFName').val(),
			lastName: $('#newBillingLName').val(),
			address1: $('#newBillingAddress').val(),
			address2: $('#newBillingAddress2').val(),
			city: $('#newBillingCity').val(),
			state: $('#newBillingState').val(),
			postCode: $('#newBillingZip').val(),
		}),
		method: 'POST',
		timeout: 0,
		headers: {
			'X-SESSION-ID': ''
		}
	};

	$.ajax(settings).done((response) => {
		if (response.result == "SUCCESS") { // check if there's an image
			loadUserOrders();
			resetFormState();
			$('#orderModal .btn-close').click();
			konnektive_user_order_details(order_id, `${btoa(getCookieValue('konnektive_customer_email'))}`);
		} else {
			resetFormState();
			throwError('error', response.message);
			debug(response);
		}
	});
}

export function konnektive_update_order_subscription(order_id, product_id, property_code) {
	$('.overlay, .processing').show();
	let settings = '';

	switch (property_code) {
		case 'subscription_restart':
			settings = {
				url: `${getConfig().konnektiveAPIURL}/purchase/update?purchaseId=` + product_id + `&reactivate=true`,
				method: 'POST',
				timeout: 0,
				headers: {
					'X-SESSION-ID': ''
				}
			};
		break;

		case 'subscription_stop':
			settings = {
				url: `${getConfig().konnektiveAPIURL}/purchase/pause?purchaseId=` + product_id + `&restartDate=` + new Date.parse('today').add(365).day().toString('MM/dd/yyyy'),
				method: 'POST',
				timeout: 0,
				headers: {
					'X-SESSION-ID': ''
				}
			};
		break;

		case 'billing_model':
			settings = {
				url: `${getConfig().konnektiveAPIURL}/purchase/update?` + buildQuery({
					purchaseId: product_id,
					nextBillDate: $('#newRecurringDate').val(),
					billingIntervalDays: $('#billingModelUpdate option:selected').val(),
				}),
				method: 'POST',
				timeout: 0,
				headers: {
					'X-SESSION-ID': ''
				}
			};
		break;
	}

		$.ajax(settings).done((response) => {
			if (response.result == "SUCCESS") {

				if(property_code == 'subscription_stop'){
					konnektive_reactivate_membership();
				}				

				loadUserOrders();
				resetFormState();
				$('#orderModal .btn-close').click();
				konnektive_user_order_details(order_id, `${btoa(getCookieValue('konnektive_customer_email'))}`);
			} else {
				resetFormState();
				throwError('error', response.message);
				debug(response);
			}
		});
}

export function konnektive_user_orders_set_images() {
		var campaignData = '';
		
		var campaignIDsIterator = '';
		$.each(getConfig().campaignID, (idKey,idValue) =>{
			campaignIDsIterator += getConfig().campaignID[idKey].id;
			if((idKey + 1) < getConfig().campaignID.length){
				campaignIDsIterator	 += ',';
			}
		})		
				
		const settings = {
			url: `${getConfig().konnektiveAPIURL}/campaign/query?campaignId=` + campaignIDsIterator + `&resultsPerPage=50&sortBy=campaignId&sortDir=0`,
			method: 'POST',
			timeout: 0,
			headers: {
				'X-SESSION-ID': ''
			}
		};
		$.ajax(settings).done((response) => {
			if (response.result == "SUCCESS") { // check if there's an image
				$.each(response.message.data, (campaignID, campaignInfo) => {
					campaignData = campaignInfo.products;
					$.each(campaignData, (pi, prd) => {

						$('.product-image').each(function() {
							const $curImage = $(this);
							const pID = parseInt($(this).attr('data-pid'));
							if (prd.campaignProductId == pID) {
								if (prd.imageUrl) {
									$curImage.attr("src", prd.imageUrl);
								}
							}
						});

					});
					
				})			
			}
	});
}

export function konnektive_forgot_password(customer_email) {
	konnektive_create_member(customer_email);
}

export function konnektive_reactivate_membership(){
	const settings = {
		url: `${getConfig().konnektiveAPIURL}/members/reactivate?` + 
			`&clubId=` + getConfig().clubID +
			`&memberId=` +  sessionStorage.getItem('member_token'),
		method: 'POST',
		timeout: 0,
		headers: {
			'X-SESSION-ID': ''
		}
	};
	$.ajax(settings).done((response) => {
		debug(response);
	});
}


export function konnektive_logout_user(){
	document.cookie = 'member_token=' + '' + ';path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
	document.cookie = 'konnektive_customer_email=' + '' + ';path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
	document.cookie = 'konnektive_customer_id=' + '' + ';path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
	deleteSessionStorage('member_token');
	deleteSessionStorage('konnektive_customer_id');
	deleteSessionStorage('konnektive_customer_email');
	window.location.href = './';
}


export function detectCarrier(trackingCode) {
	let carrier = '';

	const matchUPS1 = '\b(1Z ?[0-9A-Z]{3} ?[0-9A-Z]{3} ?[0-9A-Z]{2} ?[0-9A-Z]{4} ?[0-9A-Z]{3} ?[0-9A-Z]|[\dT]\d\d\d ?\d\d\d\d ?\d\d\d)\b';
	const matchUPS2 = '^[kKJj]{1}[0-9]{10}$';

	const matchUSPS0 = '(\b\d{30}\b)|(\b91\d+\b)|(\b\d{20}\b)';
	const matchUSPS1 = '(\b\d{30}\b)|(\b91\d+\b)|(\b\d{20}\b)|(\b\d{26}\b)| ^E\D{1}\d{9}\D{2}$|^9\d{15,21}$| ^91[0-9]+$| ^[A-Za-z]{2}[0-9]+US$/i';
	const matchUSPS2 = '^E\D{1}\d{9}\D{2}$|^9\d{15,21}$';
	const matchUSPS3 = '^91[0-9]+$';
	const matchUSPS4 = '^[A-Za-z]{2}[0-9]+US$';
	const matchUSPS5 = '(\b\d{30}\b)|(\b91\d+\b)|(\b\d{20}\b)|(\b\d{26}\b)| ^E\D{1}\d{9}\D{2}$|^9\d{15,21}$| ^91[0-9]+$| ^[A-Za-z]{2}[0-9]+US$/i';

	const matchFedex1 = '(\b96\d{20}\b)|(\b\d{15}\b)|(\b\d{12}\b)';
	const matchFedex2 = '\b((98\d\d\d\d\d?\d\d\d\d|98\d\d) ?\d\d\d\d ?\d\d\d\d( ?\d\d\d)?)\b';
	const matchFedex3 = '^[0-9]{15}$';

	const ups1 = new RegExp(matchUPS1);
	const ups2 = new RegExp(matchUPS2);

	const fedex1 = new RegExp(matchFedex1);
	const fedex2 = new RegExp(matchFedex2);
	const fedex3 = new RegExp(matchFedex3);

	const usps1 = new RegExp(matchUSPS0);
	const usps2 = new RegExp(matchUSPS1);
	const usps3 = new RegExp(matchUSPS2);
	const usps4 = new RegExp(matchUSPS3);
	const usps5 = new RegExp(matchUSPS4);
	const usps6 = new RegExp(matchUSPS5);

	if (ups1.test(trackingCode) || ups2.test(trackingCode)) {
		carrier = 'ups';
	}

	if (fedex1.test(trackingCode) || fedex2.test(trackingCode) || fedex3.test(trackingCode)) {
		carrier = 'fedex';
	}

	if (fedex1.test(trackingCode) || fedex2.test(trackingCode) || fedex3.test(trackingCode)) {
		carrier = 'fedex';
	}

	if (
		usps1.test(trackingCode) ||
		usps2.test(trackingCode) ||
		usps3.test(trackingCode) ||
		usps4.test(trackingCode) ||
		usps5.test(trackingCode) ||
		usps6.test(trackingCode)) {
		carrier = 'usps';
	}

	if (!carrier) {
		$('#shipmentTrackingLink').hide();
	} else {
		switch (carrier) {
			case 'ups':
				$('#shipmentTrackingLink').attr('href', `https://www.ups.com/mobile/track?trackingNumber=${encodeURIComponent(trackingCode)}`);
				break;
			case 'usps':
				$('#shipmentTrackingLink').attr('href', `https://tools.usps.com/go/TrackConfirmAction_input?strOrigTrackNum=${encodeURIComponent(trackingCode)}`);
				break;
			case 'fedex':
				$('#shipmentTrackingLink').attr('href', `https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=${encodeURIComponent(trackingCode)}`);
				break;
			default:
				break;
		}
		$('#shipmentTrackingLink').show();
	}
}
// Same window globals the engine exposed for these before 1.6.
Object.assign(window, {
	konnektive_validate_user,
	konnektive_create_member,
	konnektive_login_user,
	konnektive_user_orders_lookup,
	konnektive_user_order_details,
	konnektive_update_order,
	konnektive_update_order_subscription,
	konnektive_user_orders_set_images,
	konnektive_forgot_password,
	konnektive_reactivate_membership,
	konnektive_logout_user,
	detectCarrier,
});
